const initialstate = {
    data:[],
    viewdata:[],
    approvedata:[],
    rejectdata:[],
    docdata:[],
}

const AdFundDocument =  (state = initialstate, action:any)=>{
    switch (action.type){
        case 'fetch_data_success':
            return {... state, data:action.payload};
            case 'FETCH_VIEW_DATA_SUCCESS':
                return {... state, viewdata:action.payload};
                case 'Approve_DATA_SUCCESS':
                return {... state, approvedata:action.payload};
                case 'Reject_DATA_SUCCESS':
                return {... state, rejectdata:action.payload};
                case 'VIEW_DATA_SUCCESS':
                return {... state, docdata:action.payload};
            default :
            return state;
    }
};
export default AdFundDocument;